export default "__VITE_ASSET__DQYzxQQL__"